import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  ref: "targetRef",
  class: "header__lang header__lang--decorated"
}
const _hoisted_2 = {
  key: 0,
  class: "header__lang-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "header__lang-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIsVisible(true)))
    }, _toDisplayString(_ctx.savedLocale), 1),
    (_ctx.isVisible)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          _createElementVNode("li", {
            class: "header__lang-list-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLocale('ru')))
          }, " Ru "),
          _createElementVNode("li", {
            class: "header__lang-list-item",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLocale('uz')))
          }, " Uz ")
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, _ctx.onClickOutside]
  ])
}